var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"min-height":"100vh","display":"flex","flex-direction":"column"}},[_c('NavBarComp'),_c('el-main',{staticStyle:{"flex":"1","padding":"0"}},[_c('router-view')],1),_c('FooterComp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }